import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logoutIcon from "../assets/logout.png";

const LogOut = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    if (!token) return navigate("/"); // لو مفيش توكن، روح للصفحة الرئيسية

    setLoading(true);
    try {
      const res = await fetch(
        "http://backend.goldensection.agency/public/api/logout",
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.ok) {
        localStorage.removeItem("token"); // مسح التوكن
        navigate("/"); // رجوع للصفحة الرئيسية
      } else {
        console.error("فشل تسجيل الخروج");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button className="logout" onClick={handleLogout} disabled={loading}>
      <i class="fa-solid fa-arrow-right-from-bracket"></i>
    </button>
  );
};

export default LogOut;
